<template lang="pug" functional>
  .u-mt-md
    .grid.is-center.is-ultrawide-8.is-widescreen-9.is-desktop-10
      .column
        h2 {{ props.chaptersText }}
        .bookNav.u-mt-sm
          .bookNav-item(v-for="({ node }, n) in props.chapters" :key="node.title")
            AppCard.is-small(:title="node.title" :img="node.thumb" :url="`/books/${props.bookSlug}/${node.slug}`" ratio="2:1" :meta="(n <= 8) ? `${props.chapterText}: 0${ n + 1 }` : `${props.chapterText}: ${n + 1}`")

</template>

<script>
export default {
  props: {
    tag: {
      type: String,
      default: 'div'
    },
    chapters: {
      type: Array,
      required: true
    },
    bookSlug: {
      type: String,
      required: true
    },
    chaptersText: {
      type: String,
      required: true
    },
    chapterText: {
      type: String,
      required: true
    }
  }
};
</script>
